import React, { useEffect, useState } from 'react';
import EditIcon from '../../../assests/img/edit.svg?react';
import CorrectIcon from '../../../assests/img/correct.svg?react';
import WrongIcon from '../../../assests/img/wrong.svg?react';
import '../../../assests/css/edit.scss';

export interface editProps {
    onUpdate: ()=> Promise<void>,
    onClose: ()=> void,
    onEditClick?: ()=> void,
}

export default function Edit (props: editProps) {

    const {onUpdate, onClose, onEditClick} = props;

    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleEditClick = () => {
        setEdit(true);
        if (onEditClick) {
            onEditClick();
        }
    }

    const handleCloseClick = () => {
        if (onEditClick) {
            setEdit(false);
        }
        onClose();
    }

    const handleUpdateClick = async () => {
        setLoading(true);
        await onUpdate();
        setLoading(false);
        if (onEditClick) {
            setEdit(false);
        }
    }

    useEffect(()=> {
        if (!onEditClick) {
            setEdit(true);
        }
    }, [
       onEditClick,
    ])

    return (
        <div className="edit-container">
            <span className="edit-contents">
                {edit?
                <>
                    <WrongIcon width={13} height={13}
                        onClick={handleCloseClick}/>
                    {loading?
                        <span className="edit-loader"></span>:
                        <CorrectIcon onClick={handleUpdateClick}
                            width={14} height={14}/>}
                </>:
                onEditClick?
                <EditIcon width={13} height={13}
                    onClick={handleEditClick}/>: null}
            </span>
        </div>
    )

}